import { ComponentProps } from "react";

const SortIcon = (props: ComponentProps<"svg">): React.JSX.Element => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 8V1M6 1L2.5 4.5M6 1L9.5 4.5"
        stroke={"#0E0E0E"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 8L10 15M10 15L13.5 11.5M10 15L6.5 11.5"
        stroke={"#0E0E0E"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SortIcon;
